import { FunctionComponent } from "react";
import { cx } from "class-variance-authority";
import { Icon, CircleIcon } from "../Icons";

export interface SmallInfoCardProps {
  className?: string;
  iconClassName?: string;
  label: string;
  value: string;
  Icon: Icon;
}

/**
 *
 */
export const SmallInfoCard: FunctionComponent<SmallInfoCardProps> = ({
  className,
  label,
  value,
  iconClassName,
  Icon,
  ...props
}) => {
  return (
    <div
      className={cx(
        "flex gap-5 rounded-lg border border-transparent bg-white py-5 px-4",
        className
      )}
    >
      <div className="grid place-content-center">
        <CircleIcon className={iconClassName} icon={Icon} />
      </div>
      <div className="w-full-h-full flex flex-col">
        <div className="font-semibold">{label}</div>
        <div className="text-gray-700">{value}</div>
      </div>
    </div>
  );
};

export default SmallInfoCard;
